/**
 * Defer one frame so Mithril has redrawn — the currently-selected element
 * may not carry the selected class yet at reaction time. Without rAF we'd
 * scroll to the previously-selected card.
 */
export function scrollSelectedIntoListView(containerClass: string, selectedItemClass: string): void {
	requestAnimationFrame(() => {
		const container = document.querySelector(`.${containerClass}`);
		const selected = container?.querySelector(`.${selectedItemClass}`);
		if (selected != null) {
			selected.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
		}
	});
}
